import styled from 'styled-components'

const Cooling = styled.div`
  text-align: center;
`

export default Cooling
